module.exports = __webpack_public_path__ + "img/Imagemtermo.6a1a42ec.jpg";